import { Select as AntdSelect } from "antd";
import type { SelectProps } from "antd";

export const Select = (props: SelectProps) => {
  return <AntdSelect {...props} />;
};
